var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 195 194.6" },
    },
    [
      _c("g", [
        _c("path", {
          staticStyle: { fill: "#00aff0" },
          attrs: {
            d: "M83.4,9.6a9.29,9.29,0,0,0-1-.5c-.3.1-.7.1-1,.2Z",
            transform: "translate(-2.6 -2.7)",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticStyle: { fill: "#00aff0" },
          attrs: {
            d: "M9.4,82.6c-.1.3-.1.7-.2,1,.2.3.3.6.5.9Z",
            transform: "translate(-2.6 -2.7)",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticStyle: { fill: "#00aff0" },
          attrs: {
            d: "M190.3,117.2c.1-.3.1-.7.2-1-.2-.3-.3-.6-.5-.9Z",
            transform: "translate(-2.6 -2.7)",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticStyle: { fill: "#00aff0" },
          attrs: {
            d: "M115.2,189.7c.3.2.6.3.9.5.3-.1.7-.1,1-.2Z",
            transform: "translate(-2.6 -2.7)",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticStyle: { fill: "#00aff0" },
          attrs: {
            d: "M190.5,116.2c-.1.3-.1.7-.2,1l-.3-2a9.29,9.29,0,0,0,.5,1A93.44,93.44,0,0,0,192,99.5a91.22,91.22,0,0,0-7.2-35.8,92.21,92.21,0,0,0-19.7-29.3A91.86,91.86,0,0,0,100,7.5,100.55,100.55,0,0,0,82.6,9.1h0a9.29,9.29,0,0,0,1,.5l-1.9-.3c.3-.1.7-.1,1-.2A54.55,54.55,0,0,0,2.6,57.3,53.88,53.88,0,0,0,9.5,83.7c.1-.3.1-.7.2-1l.3,1.9c-.2-.3-.3-.6-.5-.9A93.07,93.07,0,0,0,8.1,99.6a91.22,91.22,0,0,0,7.2,35.8A92.21,92.21,0,0,0,35,164.7a91.86,91.86,0,0,0,65.1,26.9,96.34,96.34,0,0,0,16.1-1.4c-.3-.2-.6-.3-.9-.5l2,.3c-.3.1-.7.1-1,.2a54.79,54.79,0,0,0,26.8,7.1,54.63,54.63,0,0,0,54.5-54.5A57.11,57.11,0,0,0,190.5,116.2Zm-90.2,39.7c-32.7,0-47.4-16.1-47.4-28.1,0-6.2,4.6-10.5,10.9-10.5,14,0,10.4,20.1,36.5,20.1,13.4,0,20.8-7.3,20.8-14.7,0-4.5-2.2-9.4-11-11.6L81,103.8C57.6,97.9,53.3,85.3,53.3,73.3c0-24.7,23.3-34,45.1-34,20.1,0,43.9,11.1,43.9,26,0,6.4-5.5,10.1-11.8,10.1-12,0-9.7-16.5-33.8-16.5-11.9,0-18.6,5.4-18.6,13.1s9.4,10.2,17.6,12.1l21.5,4.8c23.6,5.3,29.6,19,29.6,32C146.9,140.9,131.5,155.9,100.3,155.9Z",
            transform: "translate(-2.6 -2.7)",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }